import router from './router'
import store, { useMyStore } from '/@/store'
import { ELocalStorageKey, ERouterName, EUserType } from '/@/types'
import { RouteRecordRaw } from 'vue-router'
import { computed } from 'vue'
import { loginByToken } from '/@/api/manage'
import { loginSuccess } from '/@/websocket/util/config'

// const store = useMyStore()

const whiteList = ['/project', '/freeLogin', '/pilot-login']

const sidebarRouters = computed(() => store.state.sidebarRouters)

router.beforeEach(async (to, from, next) => {
  if (localStorage.getItem(ELocalStorageKey.Token)) {
    const flag: number = Number(localStorage.getItem(ELocalStorageKey.Flag))
    switch (flag) {
      case EUserType.Web:
        if (to.path === '/project' || to.path === '/') {
          next()
        } else {
          if (sidebarRouters.value.length > 0) {
            next()
          } else {
            try {
              store.dispatch('GenerateRoutes').then(accessRoutes => {
                accessRoutes.forEach((route: RouteRecordRaw) => {
                  router.addRoute(route)
                })
                next({ ...to, replace: true })
              })
            } catch (err) {
              next('/404')
            }
          }
        }
        break
      case EUserType.Pilot:
        next()
        break
      default:
        next()
        break
    }
  } else {
    // 没有token
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next()
    } else if (to.path.startsWith('/large_screen')) {
      const urlToken = to.query.token
      // 有 token → 尝试免登录
      if (urlToken) {
        try {
          const res = await loginByToken(<loginByToken>{ token: urlToken })
          if (res.code === 0) {
            loginSuccess(res)
            // 登录成功后去掉 token 参数（防止泄露）
            next({ path: to.path, query: {} })
            return
          }
        } catch (err) {
          console.error('Token 登录失败', err)
          next('/project')
        }
      } else {
        next('/project')
      }
    } else if (to.path.startsWith('/manage_device')) {
      const urlToken = to.query.token
      // 有 token → 尝试免登录
      if (urlToken) {
        try {
          const res = await loginByToken(<loginByToken>{ token: urlToken })
          if (res.code === 0) {
            loginSuccess(res)
            // 登录成功后去掉 token 参数（防止泄露）
            next({ path: to.path, query: { id: to.query.id, deviceSn: to.query.deviceSn } })
            return
          }
        } catch (err) {
          console.error('Token 登录失败', err)
          next('/project')
        }
      } else {
        next('/project')
      }
    } else {
      next('/project') // 否则全部重定向到登录页
    }
    // next()
  }
})
